import script from "./TextWithBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TextWithBar.vue?vue&type=script&setup=true&lang=js"

import "./TextWithBar.vue?vue&type=style&index=0&id=8d89d858&scoped=true&lang=scss"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d89d858"]])

export default __exports__